/* tslint:disable */
import { Injectable } from '@angular/core';
import { HttpClient, HttpRequest, HttpResponse, HttpHeaders } from '@angular/common/http';
import { BaseService as __BaseService } from '../base-service';
import { ApiConfiguration as __Configuration } from '../api-configuration';
import { StrictHttpResponse as __StrictHttpResponse } from '../strict-http-response';
import { Observable as __Observable } from 'rxjs';
import { map as __map, filter as __filter } from 'rxjs/operators';

import { LasgroUser_notificationCollection } from '../models/lasgro-user-_notification-collection';
@Injectable({
  providedIn: 'root',
})
class UserNotificationRecordService extends __BaseService {
  static readonly userNotificationRecordListPath = '/notifications';

  constructor(
    config: __Configuration,
    http: HttpClient
  ) {
    super(config, http);
  }

  /**
   * list user_notification_record
   *
   * List all of the user notifications
   *
   * Required security scopes:
   *   * `api:access`
   * @return OK
   */
  userNotificationRecordListResponse(): __Observable<__StrictHttpResponse<LasgroUser_notificationCollection>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;
    let req = new HttpRequest<any>(
      'GET',
      this.rootUrl + `/notifications`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'json'
      });

    return this.http.request<any>(req).pipe(
      __filter(_r => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<LasgroUser_notificationCollection>;
      })
    );
  }
  /**
   * list user_notification_record
   *
   * List all of the user notifications
   *
   * Required security scopes:
   *   * `api:access`
   * @return OK
   */
  userNotificationRecordList(): __Observable<LasgroUser_notificationCollection> {
    return this.userNotificationRecordListResponse().pipe(
      __map(_r => _r.body as LasgroUser_notificationCollection)
    );
  }
}

module UserNotificationRecordService {
}

export { UserNotificationRecordService }
